import { MessageCircle } from 'lucide-react';
import { useIntl } from 'react-intl';

import { Button } from '@/shared/ui/button';

import { useAuth } from './auth-provider';
import { useLanguage } from './language-provider';

export const HelpButton = () => {
  const { isGuest } = useAuth();
  const { language } = useLanguage();
  const intl = useIntl();

  return (
    <Button
      onClick={() => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        window.Tally.openPopup(
          language === 'en'
            ? import.meta.env.VITE_TALLY_FORM_ID_US
            : import.meta.env.VITE_TALLY_FORM_ID_UA,
          {
            hiddenFields: {
              pageHref: location.href,
              // email: 'alice@example.com',
              guestOrUser: isGuest ? 'guest' : 'user',
            },
          },
        );
      }}
    >
      <MessageCircle />

      <p>{intl.formatMessage({ id: 'help' })}</p>
    </Button>
  );
};
